import React from 'react'

import { Portlet, Table } from '_zari/core'

import * as InventarioService from 'services/inventario.service'

import * as Modals from './modals'

const portletBreadcrumbs = [{ name: 'Kardex' }]

const InformeKardex = ({ sectionData }) => {
  const [detalles, setDetalles] = React.useState([])
  const [mostrarDetallesModal, setMostrarDetallesModal] = React.useState(false)
  const [modalData, setModalData] = React.useState(null)
  // const [filtros, setFiltros] = React.useState({})

  React.useEffect(() => {
    const { data } = sectionData
    // setFiltros(filtros)
    setDetalles(data)
  }, [sectionData])

  const clickVerDetalles = React.useCallback((idDetalle, row) => {
    InventarioService.obtenerKardexDetallexIdAsConsultaModalTable(idDetalle).then(({ data }) => {
      setModalData({ ...data, ruc: row?.ruc, razSoc: row?.razSoc })
      setMostrarDetallesModal(true)
    })
  }, [])

  return (
    <>
      <Portlet>
        <Portlet.Header title='Consulta Kardex' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          {/* <Form.Label text={`Saldo Anterior: ${saldoAnterior}`}></Form.Label> */}
          <Table
            title='Reporte Kardex x Producto'
            flagDownload
            className='text-center'
            filas={detalles}
            maxRowsShown={10}
            headRows={[
              { label: 'PRODUCTO', key: 'nombre' },
              { label: 'FECHA', key: 'fecha' },
              { label: 'ESTABLECIMIENTO', key: 'sede' },
              { label: 'TIPO', key: 'tipo' },
              { label: 'SERIE', key: 'serie' },
              { label: 'NUMERO', key: 'numero' },
              { label: 'TIPO MOV', key: 'tipoMov' },
              { label: 'INGRESO', key: 'ingreso' },
              { label: 'SALIDA', key: 'salida' },
              { label: 'SALDO', key: 'saldo' },
              { label: 'PRECIO', key: 'precio' },
              {}
            ]}
            rowTemplate={(row, key) => {
              const bg = row.saldo > 0 ? '' : '#EF9A9A'
              return (
                <Table.Row key={key}>
                  <Table.Cell style={{ backgroundColor: bg }}>
                    {row.codigo ? <small className='text-muted d-block'>{row.codigo}</small> : null}
                    {row.nombre || '---'}
                  </Table.Cell>
                  <Table.Cell className='text-center' style={{ backgroundColor: bg }}>{row.fecha}</Table.Cell>
                  <Table.Cell className='text-center' style={{ backgroundColor: bg }}>{row.sede}</Table.Cell>
                  <Table.Cell className='text-center' style={{ backgroundColor: bg }}>{row.tipo}</Table.Cell>
                  <Table.Cell className='text-center' style={{ backgroundColor: bg }}>{row.serie}</Table.Cell>
                  <Table.Cell className='text-center' style={{ backgroundColor: bg }}>{row.numero}</Table.Cell>
                  <Table.Cell className='text-center' style={{ backgroundColor: bg }}>{row.tipoMov}</Table.Cell>
                  <Table.Cell className='text-center' style={{ backgroundColor: bg }}>{row.ingreso}</Table.Cell>
                  <Table.Cell className='text-center' style={{ backgroundColor: bg }}>{row.salida}</Table.Cell>
                  <Table.Cell className='text-center' style={{ backgroundColor: bg }}>{row.saldo}</Table.Cell>
                  <Table.Cell className='text-center' style={{ backgroundColor: bg }}>{row.precio}</Table.Cell>
                  {row.tipo ? (
                    <Table.Cell>
                      <Table.Dropdown>
                        {({ handleClose }) => [
                          <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickVerDetalles(row.idKardex, row)}>
                            Ver Detalles
                          </Table.Dropdown.Item>
                        ]}
                      </Table.Dropdown>
                    </Table.Cell>
                  ) : (
                    <Table.Cell className='text-center'></Table.Cell>
                  )}
                </Table.Row>
              )
            }}
          />
        </Portlet.Body>
      </Portlet>
      {mostrarDetallesModal && (
        <Modals.TablaDetalleModal handleClose={() => setMostrarDetallesModal(false)} show={mostrarDetallesModal} modalData={modalData} />
      )}
    </>
  )
}

export default React.memo(InformeKardex)
